import { mapState } from 'vuex';


var faq = {
    en : [
        {
            caption : `What is Snippity?`,
            text : `Snippity is a magical app that uses neural networks to convey information to children in simple terms, adapting to the child's age. Events happen around us every day, and Snippity turns these events into a story with pleasant music, voiceover, and pictures.`
        },
        {
            caption : `What age is this app for?`,
            text : `The app is designed for children up to 7 years old. The story generation algorithms have specific parameters for each age group: what information to filter and what style of presentation to use.`
        },
        {
            caption : `Where can I download the app?`,
            text : `Snippity is available for iOS in the App Store and for Android in the Ru Store. The browser version also supports all Snippity features.`
        },
        {
            caption: `Advertising, subscription, monetization, data.`,
            text: `Snippity is available by subscription with a free trial. Therefore, the app is ad-free and doesn't collect data.`
        },
        {
            caption: `How will the project develop further?`,
            text: `Snippity is currently developing courses for children on a variety of topics, such as: "Why does the sun shine?", "Why does it rain?", and "How does wheat grow?" The questions can be answered in different ways, but each of them could be suitable for a training course, which Snippity will create.`
        }
    ],
    ru : [
        {
            caption : `Что такое Snippity?`,
            text : `Snippity это сказочное приложение, которое с помощью нейросетей рассказывает детям информацию простыми словами, подстраиваясь под возраст ребенка. Каждый день вокруг нас происходят события, Snippity делает из событий сегодняшнего дня рассказ-историю с приятной музыкой, озвучкой и картинками.`
        },
        {
            caption : `Для какого возраста это приложение?`,
            text : `Приложение рассчитано на детей возраста до 7 лет. Для каждого возраста в алгоритмы генерации историй введены свои параметры: какую информацию фильтровать, какой стиль изложения использовать.`
        },
        {
            caption : `Где можно скачать приложение?`,
            text : `Snippity доступен для iOS в Appstore и для Android в Rustore. Также браузерная версия поддерживают все возможности Snippity.`
        },
        {
            caption : `Реклама, подписка, монетизация, данные.`,
            text : `Snippity доступен по подписке с бесплатным пробным периодом. Поэтому в приложении нет рекламы и оно не собирает данные.`
        },
        {
            caption : `Как будет дальше развиваться проект?`,
            text : `В Snippity сейчас ведется разработка курсов для детей на самые разные темы, например: "Почему светит солнце?", "Почему идёт дождь?", "Как растёт пшеница?". На вопросы можно ответить по-разному, но каждый из них может может претендовать на обучающий курс, который Snippity и сделает.`
        }
    ]
}

export default {
    name: 'faq',
    props: {
        collapse : Boolean
    },

    data : function(){

        return {
            loading : false,
            faq : faq,
            expanded : {}
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        faqL : function(state){
            return this.faq[state.locale] || this.faq.en
        }
    }),

    methods : {
        expandcollapse : function(index){
            if(!this.collapse) return

            this.$set(this.expanded, index, !!!this.expanded[index])
        }
    },
}